// const MultibuyApp = (() => {

//   // ─────────────────────────────────────────────
//   // PRIVATE STATE
//   // ─────────────────────────────────────────────

//   let PRICING = { basePrice: 0, tiers: [] };
//   let popupTimeout;
//   let digitisationVariant= "47828254261435";
//   let totalPrice = 0;
//   let discountedTotal = 0; 

//   function showQtyPopup(message) {
//     const popup = document.getElementById("qty-popup");
//     if (!popup) return;

//     popup.querySelector(".qty-popup-text").textContent = message;

//     popup.classList.add("show");

//     clearTimeout(popupTimeout);
//     popupTimeout = setTimeout(() => {
//       popup.classList.remove("show");
//     }, 2000);
//   }

//   /**
//    * Cached DOM references — populated once in init().
//    * Never query the DOM in hot paths (stepper clicks, input events).
//    */
//   const EL = {
//     $form:           null,   // #multi-add-atc
//     $submitBtn:      null,   // [type="submit"]
//     $formError:      null,   // #form-error
//     $liveTotal:      null,   // #live-total-price
//     $liveOriginal:   null,   // #live-original-price
//     $liveSavings:    null,   // #live-savings
//     $liveSavingsAmt: null,   // #live-savings-amount
//     $designBox:      null,   // .your-design-box
//     $fontPreview:    null,   // #fontPreview
//     $fontSelect:     null,   // #fontFamilySelect
//     $textInput:      null,   // #customTextInput
//     $logoNameInput:  null,   // #logoNameInput
//     $disclaimer:     null,   // #designDisclaimer
//   };

//   /**
//    * Tab context map — built once per [data-tabs] container.
//    * Stores the filtered button/panel sets scoped to that exact container,
//    * so switchTab never has to do per-element DOM traversals at click time.
//    *
//    * Map<HTMLElement, { $buttons: jQuery, $panels: jQuery }>
//    */
//   const TAB_CONTEXTS = new Map();

//   // ─────────────────────────────────────────────
//   // UTILS
//   // ─────────────────────────────────────────────

//   const debounce = (fn, wait) => {
//     let timer;
//     return function (...args) {
//       clearTimeout(timer);
//       timer = setTimeout(() => fn.apply(this, args), wait);
//     };
//   };

//   const formatMoney = (cents) => {
//     const amount = (cents / 100).toFixed(2);
//     const fmt    = window.shopMoneyFormat;
//     if (!fmt) return `$${amount}`;
//     return fmt.replace(/\{\{[\s]*amount[\s]*\}\}/g, amount);
//   };

//   // ─────────────────────────────────────────────
//   // ERROR / VALIDATION HELPERS
//   // ─────────────────────────────────────────────

//   const showError = (msg) => {
//     if (!msg) {
//       EL.$formError.hide().text('');
//       return;
//     }
//     EL.$formError.text(msg).show();
//     EL.$formError[0].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
//   };

//   /** Mark a field as invalid with an inline error message. */
//   const setFieldError = ($field, msg) => {
//     $field.addClass('field--error').attr('aria-invalid', 'true');

//     const errorId  = `err-${$field.attr('id') || $field.attr('name') || Math.random().toString(36).slice(2)}`;
//     let   $errSpan = $(`#${errorId}`);

//     if (!$errSpan.length) {
//       $errSpan = $(`<span class="field-error-msg" id="${errorId}" role="alert"></span>`);
//       $field.after($errSpan);
//     }

//     $errSpan.text(msg).show();
//     $field.attr('aria-describedby', errorId);
//   };

//   /** Clear error state from a field. */
//   const clearFieldError = ($field) => {
//     const errorId = $field.attr('aria-describedby'); // get BEFORE removing
//     $field.removeClass('field--error').removeAttr('aria-invalid aria-describedby');
//     if (errorId) $(`#${errorId}`).hide();
//   };

//   /** Clear ALL field-level errors across the form. */
//   const clearAllFieldErrors = () => {
//     EL.$form.find('.field--error').removeClass('field--error').removeAttr('aria-invalid aria-describedby');
//     EL.$form.find('.field-error-msg').hide();
//   };

//   // ─────────────────────────────────────────────
//   // PRICING CONFIG — read from window.discountTiers
//   // ─────────────────────────────────────────────

//   const loadPricingConfig = () => {
//     const data = window.discountTiers;

//     PRICING = {
//       tiers: data.tiers.map(t => ({
//         min: parseInt(t.min, 10) || 0,
//         discount: parseFloat(t.discount) || 0
//       }))
//     };
//   };

//   // ─────────────────────────────────────────────
//   // PRICING LOGIC
//   // ─────────────────────────────────────────────

//   const getTier = (qty) => {
//     let tier = PRICING.tiers[0];
//     PRICING.tiers.forEach((t) => { if (qty >= t.min) tier = t; });
//     return tier;
//   };

//   const getTotalQty = () => {
//     let total = 0;
//     EL.$form.find('.quantity-input').each(function () {
//       total += parseInt(this.value, 10) || 0;
//     });
//     return total;
//   };

//   // ─────────────────────────────────────────────
//   // CART SUMMARY — reads batched before writes (no layout thrashing)
//   // ─────────────────────────────────────────────

//   // const updateCartSummary = () => {
//   //   // ── PHASE 1: read all values from DOM ──
//   //   let totalQty      = 0;
//   //   let originalTotal = 0;
//   //   let addonTotal    = 0;

//   //   EL.$form.find('.pro-box.active .quantity-input').each(function () {
//   //     const qty       = parseInt(this.value, 10) || 0;
//   //     const basePrice = parseFloat(this.dataset.basePrice) || 0;
//   //     if (qty > 0) {
//   //       totalQty      += qty;
//   //       originalTotal += qty * basePrice * 100;
//   //     }
//   //   });

//   //   debugger;

//   //   EL.$form.find('.addon-variant-id:not(:disabled)').each(function () {
//   //     const basePrice = parseFloat(this.dataset.basePrice) || 0;
//   //     addonTotal += basePrice * totalQty * 100;
//   //   });

//   //   // ── PHASE 2: compute ──
//   //   const tier            = getTier(totalQty);
    
//   //   const discountedTotal = originalTotal * (1 - tier.discount / 100) + addonTotal;
//   //   const savings         = originalTotal - (originalTotal * (1 - tier.discount / 100));

//   //   // ── PHASE 3: write to DOM (all at once via rAF) ──
//   //   requestAnimationFrame(() => {
//   //     EL.$liveTotal.text(formatMoney(discountedTotal));

//   //     if (savings > 0) {
//   //       EL.$liveOriginal.text(formatMoney(originalTotal)).show();
//   //       EL.$liveSavings.show();
//   //       EL.$liveSavingsAmt.text(formatMoney(savings));
//   //     } else {
//   //       EL.$liveOriginal.hide();
//   //       EL.$liveSavings.hide();
//   //     }
//   //   });
//   // };

//   const updateCartSummary = () => {
//     // ── PHASE 1: read all values from DOM ──
//     let totalQty      = 0;
//     let originalTotal = 0; // in cents
//     let addonTotal    = 0; // in cents

//     // ── FIRST PASS: get total quantity ──
//     EL.$form.find('.pro-box.active .quantity-input').each(function () {
//       const qty = parseInt(this.value, 10) || 0;
//       if (qty > 0) totalQty += qty;
//     });

//     // ── GET TIER AFTER QTY ──
//     const tier = getTier(totalQty);
//     const discountPercent = tier?.discount || 0;

//     let discountedProductsTotal = 0;

//     // ── SECOND PASS: Shopify-style per-unit calculation ──
//     EL.$form.find('.pro-box.active .quantity-input').each(function () {
//       const qty = parseInt(this.value, 10) || 0;
//       if (!qty) return;

//       const basePriceCents = Math.round(
//         (parseFloat(this.dataset.basePrice) || 0) * 100
//       );

//       // original total
//       originalTotal += qty * basePriceCents;

//       // 🔥 Shopify-style: discount per unit, then round
//       const discountedUnitPrice = Math.round(
//         basePriceCents * (1 - discountPercent / 100)
//       );

//       discountedProductsTotal += qty * discountedUnitPrice;
//     });

//     // ── ADDONS (NO DISCOUNT) ──
//     EL.$form.find('.addon-variant-id:not(:disabled)').each(function () {
//       const basePriceCents = Math.round(
//         (parseFloat(this.dataset.basePrice) || 0) * 100
//       );

//       addonTotal += basePriceCents * totalQty;
//     });

//     // ── FINAL CALCULATIONS ──
//     const finalTotal = discountedProductsTotal + addonTotal;
//     const savings    = originalTotal - discountedProductsTotal;

//     // ── PHASE 3: write to DOM ──
//     requestAnimationFrame(() => {
//       EL.$liveTotal.text(formatMoney(finalTotal));

//       if (savings > 0) {
//         EL.$liveOriginal.text(formatMoney(originalTotal)).show();
//         EL.$liveSavings.show();
//         EL.$liveSavingsAmt.text(formatMoney(savings));
//       } else {
//         EL.$liveOriginal.hide();
//         EL.$liveSavings.hide();
//       }
//     });
//   };
//   // ─────────────────────────────────────────────
//   // TAB SYSTEM — context map eliminates per-click DOM traversal
//   // ─────────────────────────────────────────────

//   /**
//    * Build TAB_CONTEXTS once at init.
//    * For each [data-tabs] container, precompute the scoped button/panel sets
//    * so switchTab never runs .closest() inside a loop.
//    */
//   const buildTabContexts = () => {
//     $('[data-tabs]').each(function () {
//       const container = this;
//       const $container = $(container);

//       // Only include buttons/panels whose immediate [data-tabs] ancestor is THIS container
//       const $buttons = $container.find('[data-tab-target]').filter(function () {
//         return $(this).closest('[data-tabs]')[0] === container;
//       });

//       const $panels = $container.find('[data-tab-panel]').filter(function () {
//         return $(this).closest('[data-tabs]')[0] === container;
//       });

//       TAB_CONTEXTS.set(container, { $buttons, $panels });
//     });
//   };

//   /**
//    * O(1) context lookup — no DOM traversal inside the click handler.
//    */
//   const switchTab = ($btn) => {
//     const container = $btn.closest('[data-tabs]')[0];
//     if (!container) return;

//     const ctx = TAB_CONTEXTS.get(container);
//     if (!ctx) return;

//     const target = $btn.data('tab-target');

//     // Batch all class changes together
//     ctx.$buttons.removeClass('is-active');
//     ctx.$panels.removeClass('is-active');

//     $btn.addClass('is-active');

//     const $panel = ctx.$panels.filter(`[data-tab-panel="${target}"]`);
//     if ($panel.length) {
//       $panel.addClass('is-active');

//       // Focus management for keyboard / a11y
//       $panel
//         .find('button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')
//         .first()
//         .focus();
//     }
//   };

//   const bindTabClicks = () => {
//     // Direct bind — all tab buttons exist at page load
//     $('[data-tab-target]').not('.next-step-btn').on('click', function () {
//       if ($(this).is('[disabled]')) return;
//       switchTab($(this));
//     });

//     // next-step-btn finds and activates the matching HEADER tab button
//     $('.next-step-btn').on('click', function (e) {
//       e.preventDefault();

//       const $btn       = $(this);
//       const target     = $btn.data('tab-target');
//       const container  = $btn.closest('[data-tabs]')[0];
//       if (!container) return;

//       const ctx = TAB_CONTEXTS.get(container);
//       if (!ctx) return;

//       const $headerBtn = ctx.$buttons
//         .filter(`[data-tab-target="${target}"]`)
//         .not('.next-step-btn');

//       if ($headerBtn.length && !$headerBtn.is('[disabled]')) {
//         switchTab($headerBtn);
//       }
//     });
//   };

//   // ─────────────────────────────────────────────
//   // JOURNEY STATE
//   // ─────────────────────────────────────────────

//   const updateJourneyState = ($context) => {
//     const totalQty = getTotalQty();

//     const $panel     = $context.closest('[data-tab-panel]');
//     const panelId    = $panel.data('tab-panel');
//     const container  = $panel.closest('[data-tabs]')[0];
//     if (!container) return;

//     const ctx = TAB_CONTEXTS.get(container);
//     if (!ctx) return;

//     ctx.$buttons
//       .filter(`[data-tab-target="${panelId}"]`)
//       .toggleClass('journey-complete', totalQty > 0);

//     const $nextBtn = $panel.find('.next-step-btn');
//     if (!$nextBtn.length) return;

//     const nextTarget  = $nextBtn.data('tab-target');
//     const $nextTabBtn = ctx.$buttons
//       .filter(`[data-tab-target="${nextTarget}"]`)
//       .not('.next-step-btn');

//     if (totalQty > 0) {
//       $nextBtn.removeAttr('disabled');
//       $nextTabBtn.removeAttr('disabled');
//     } else {
//       $nextBtn.attr('disabled', true);
//       $nextTabBtn.attr('disabled', true);
//     }
//   };

//   // ─────────────────────────────────────────────
//   // QUANTITY STEPPER
//   // ─────────────────────────────────────────────

//   const updateState = ($input, value) => {
//     const maxAttr = parseInt($input.attr('max'), 10);
//     const max     = isNaN(maxAttr) ? Infinity : maxAttr;

//     value = Math.min(max, Math.max(0, parseInt(value, 10) || 0));
//     $input.val(value);

//     $input.closest('.pro-box').toggleClass('active', value > 0);

//     updateCartSummary();
//     updateJourneyState($input);
//     showError('');
//   };

//   const bindSteppers = () => {
//     EL.$form.find('.qty-stepper').each(function () {
//       const $stepper = $(this);
//       const $input   = $stepper.find('.quantity-input');
//       const $plus    = $stepper.find('.qty-plus');
//       const $minus   = $stepper.find('.qty-minus');

//       const isAvailable     = this.dataset.available === 'true';
//       const isTracked       = this.dataset.trackInventory === "shopify";
//       const availableQty    = parseInt(this.dataset.availableQuantity, 10);
//       const inventoryPolicy = this.dataset.inventoryPolicy;

//       // Decide max quantity
//       let maxQty;
//       if (isTracked && inventoryPolicy !== 'continue') {
//         maxQty = Math.max(availableQty, 0);
//       } else {
//         maxQty = 999; // fallback
//       }

//       // Minus click
//       $minus.on('click', () => {
//         let value = Number($input.val()) || 0;
//         value = Math.max(0, value - 1);
//         updateState($input, value);
//       });

//       $plus.on('click', () => {
//         if (!isAvailable) return;

//         let value = Number($input.val()) || 0;

//         if (value >= maxQty) {
//           showQtyPopup("You've reached the maximum available quantity");
//           return;
//         }

//         value = Math.min(maxQty, value + 1);
//         updateState($input, value);
//       });

//       // Manual input
//       $input.on('input', debounce(function () {
//         let value = Number(this.value) || 0;

//         if (value > maxQty) value = maxQty;
//         if (value < 0) value = 0;

//         updateState($input, value);
//       }, 150));
//     });
//   };

//   // ─────────────────────────────────────────────
//   // VALIDATION
//   // ─────────────────────────────────────────────

//   /**
//    * Full form validation before cart submission.
//    * Returns { valid: true } or { valid: false, msg: string, $focus: jQuery }.
//    *
//    * Covers:
//    *  1. At least one qty > 0
//    *  2. Logo tab active → logo name, image upload, disclaimer
//    *  3. Text tab active → custom text, font family (if select present)
//    *  4. Active addon rows with a text input → text required
//    */
//   const validateForm = () => {
//     clearAllFieldErrors();

//     // ── 1. Quantity ──
//     if (getTotalQty() === 0) {
//       return {
//         valid: false,
//         msg:   'Please select at least one product before adding to cart.',
//       };
//     }

//     // ── 2. Design tab fields ──
//     const $activeDesignPanel = EL.$designBox.find('[data-tab-panel].is-active');
//     const activeDesignTab    = $activeDesignPanel.data('tab-panel'); // 'design-logo' | 'design-text'

//     if (activeDesignTab === 'design-logo') {
//       // Logo name
//       const logoName = EL.$logoNameInput.val().trim();
//       if (!logoName) {
//         setFieldError(EL.$logoNameInput, 'Please enter your logo name.');
//         return {
//           valid:  false,
//           msg:    'Please complete all required fields.',
//           $focus: EL.$logoNameInput,
//         };
//       }

//       // Logo image upload — FilePond stores the uploaded file reference here
//       const $filePondInput = EL.$form.find('[data-tab-panel="design-logo"].is-active .filepond--data input');
//       const hasImage       = $filePondInput.length && $filePondInput.val();

//       // Also check for a native file input fallback
//       const $nativeFile = EL.$form.find('[data-tab-panel="design-logo"].is-active input[type="file"]');
//       const hasNative   = $nativeFile.length && $nativeFile[0].files && $nativeFile[0].files.length > 0;

//       if (!hasImage && !hasNative) {
//         return {
//           valid: false,
//           msg:   'Please upload your design image before continuing.',
//         };
//       }

//       // Disclaimer checkbox
//       if (!EL.$disclaimer.is(':checked')) {
//         setFieldError(EL.$disclaimer, 'You must confirm ownership of the artwork.');
//         return {
//           valid:  false,
//           msg:    'Please confirm you own the rights to the artwork.',
//           $focus: EL.$disclaimer,
//         };
//       }
//     }

//     if (activeDesignTab === 'design-text') {
//       // Custom text
//       const customText = EL.$textInput.val().trim();
//       if (!customText) {
//         setFieldError(EL.$textInput, 'Please enter your custom text.');
//         return {
//           valid:  false,
//           msg:    'Please enter your custom text.',
//           $focus: EL.$textInput,
//         };
//       }

//       // Font family (only if the select exists in the DOM)
//       if (EL.$fontSelect.length && !EL.$fontSelect.val()) {
//         setFieldError(EL.$fontSelect, 'Please select a font family.');
//         return {
//           valid:  false,
//           msg:    'Please select a font family.',
//           $focus: EL.$fontSelect,
//         };
//       }
//     }

//     // ── 3. Addon text fields ──
//     let addonError  = null;
//     let $addonFocus = null;

//     EL.$form.find('.addon-row.active').each(function () {
//       const $row         = $(this);
//       const $textWrapper = $row.find('.addon-text-field');

//       if (!$textWrapper.length || $textWrapper.hasClass('hidden')) return;

//       const $field = $textWrapper.find('input[type="text"], textarea').first();
//       if (!$field.length) return;

//       if (!$field.val().trim()) {
//         const addonTitle = $row.find('.addon-title').text().trim() || 'addon';
//         setFieldError($field, `Please enter text for "${addonTitle}".`);
//         addonError  = `Please enter the required text for the "${addonTitle}" option.`;
//         $addonFocus = $field;
//         return false; // break each
//       }
//     });

//     if (addonError) {
//       return { valid: false, msg: addonError, $focus: $addonFocus };
//     }

//     return { valid: true };
//   };

//   // ─────────────────────────────────────────────
//   // CUSTOM PROPERTIES COLLECTOR
//   // ─────────────────────────────────────────────

//   /**
//    * Collects all active custom properties for cart line item properties.
//    *
//    * Tab filtering rules:
//    *  - Any field with [data-design-tab] that is INSIDE .your-design-box
//    *    is only collected if its tab is currently active.
//    *  - Fields with [data-design-tab] that are OUTSIDE .your-design-box
//    *    (e.g. the Special Details textarea) are always collected — the
//    *    attribute is ignored for scoping purposes.
//    */
//   const getCustomProperties = () => {
//     const properties     = {};
//     const $activePanel   = EL.$designBox.find('[data-tab-panel].is-active');
//     const activeDesignId = $activePanel.data('tab-panel'); // e.g. 'design-logo'

//     EL.$form.find('.custom-prop').each(function () {
//       const $input = $(this);
//       const name   = $input.attr('name');
//       if (!name) return;
//       if ($input.attr('disabled')) return;

//       // Skip invisible non-checkable fields
//       const isHidden    = !$input.is(':visible');
//       const isCheckable = $input.is(':radio, :checkbox');
//       if (isHidden && !isCheckable) return;

//       // Apply design-tab scoping ONLY when the field lives inside .your-design-box
//       const fieldTab      = $input.data('design-tab');
//       const insideDesign  = $input.closest('.your-design-box').length > 0;

//       if (fieldTab && insideDesign) {
//         if (activeDesignId !== `design-${fieldTab}`) return;
//       }

//       const type = $input.attr('type');

//       if (type === 'radio') {
//         if ($input.is(':checked')) properties[name] = $input.val();
//       } else if (type === 'checkbox') {
//         if ($input.is(':checked')) {
//           properties[name] = properties[name]
//             ? `${properties[name]}, ${$input.val()}`
//             : $input.val();
//         }
//       } else {
//         const val = $input.val();
//         if (val && val.trim() !== '') properties[name] = val.trim();
//       }
//     });

//     return properties;
//   };

//   // ─────────────────────────────────────────────
//   // ADDON HANDLER
//   // ─────────────────────────────────────────────

//   const bindAddonButtons = () => {
//     EL.$form.find('.addon-add-btn').on('click', function () {
//       const $btn  = $(this);
//       const $row  = $btn.closest('.addon-row');

//       $row.toggleClass('active');
//       const isActive = $row.hasClass('active');

//       $row.find('.addon-variant-id').prop('disabled', !isActive);

//       const $textWrapper = $row.find('.addon-text-field');
//       if ($textWrapper.length) {
//         $textWrapper.toggleClass('hidden', !isActive);
//         $textWrapper.find('input, textarea, select').prop('disabled', !isActive);

//         if (!isActive) {
//           clearFieldError($textWrapper.find('input, textarea').first());
//         }
//       }

//       updateCartSummary();
//     });

//     EL.$form.find('.addon-text-field input, .addon-text-field textarea').on('input', function () {
//       clearFieldError($(this));
//     });
//   };

//   // ─────────────────────────────────────────────
//   // PRICING POPUP
//   // ─────────────────────────────────────────────

//   const bindPricingPopup = () => {
//     const closeAllPopups = () => {
//       EL.$form.find('.pricing-popup.is-open')
//         .removeClass('is-open')
//         .attr('aria-hidden', 'true');
//     };

//     EL.$form.find('.open-pricing-popup').on('click', function (e) {
//       e.preventDefault();
//       const target = $(this).data('target');
//       if (!target) return;

//       closeAllPopups();
//       $(target).addClass('is-open').attr('aria-hidden', 'false');
//     });

//     EL.$form.find('.pricing-popup__overlay, .pricing-popup__close').on('click', function () {
//       $(this).closest('.pricing-popup')
//         .removeClass('is-open')
//         .attr('aria-hidden', 'true');
//     });

//     $(document).on('keydown.multibuy', (e) => {
//       if (e.key === 'Escape') closeAllPopups();
//     });
//   };

//   // ─────────────────────────────────────────────
//   // CART API HELPER
//   // ─────────────────────────────────────────────

//   /**
//    * POST a batch of items to /cart/add.js.
//    * Returns { ok: bool, data: object }.
//    * Throws only on network failure (fetch itself rejects).
//    */
//   const cartAdd = async (items) => {
//     const res  = await fetch('/cart/add.js', {
//       method:  'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body:    JSON.stringify({ items }),
//     });
//     const data = await res.json();
//     return { ok: res.ok, data };
//   };

//   // ─────────────────────────────────────────────
//   // FORM SUBMIT
//   // ─────────────────────────────────────────────

//   const bindFormSubmit = () => {
//     EL.$form.on('submit', async function (e) {
//       e.preventDefault();
//       showError('');

//       if (EL.$form.hasClass('loading')) return;

//       // ── Validate first ──
//       const check = validateForm();
//       if (!check.valid) {
//         showError(check.msg);
//         if (check.$focus && check.$focus.length) {
//           check.$focus[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
//           check.$focus.focus();
//         }
//         return;
//       }

//       EL.$form.addClass('loading');
//       EL.$submitBtn.attr('disabled', true);
//       let totalQty = 0;

//       const globalProperties = getCustomProperties();

//       // FilePond image reference
//       const $filepond = EL.$form.find('[data-tab-panel="design-logo"].is-active .filepond--data input');
//       if ($filepond.length && $filepond.val()) {
//         globalProperties['Logo Image'] = $filepond.val();
//       }

//       // ── Build base product items ──
//       const baseItems = [];
//       EL.$form.find('.quantity-input').each(function () {
//         const qty       = parseInt(this.value, 10) || 0;
//         const variantId = Number(this.dataset.variantId);

//         if (qty > 0) {
//           if (!variantId) {
//             console.warn('[custom-multibuy] Missing variant ID on:', this);
//             return;
//           }
//           totalQty += qty;
//           baseItems.push({ id: variantId, quantity: qty, properties: globalProperties });
//         }
//       });

//       if (!baseItems.length) {
//         showError('Please select at least one product before adding to cart.');
//         EL.$form.removeClass('loading');
//         EL.$submitBtn.removeAttr('disabled');
//         return;
//       }

//       // ── Build addon items ──
//       const addonItems = [];
//       EL.$form.find('.addon-variant-id:not(:disabled)').each(function () {
//         const variantId = Number(this.value);
//         if (!variantId) {
//           console.warn('[custom-multibuy] Missing addon variant ID on:', this);
//           return;
//         }

//         // Addon-specific text is scoped to its own line item only
//         const addonProperties = {};
//         const $row            = $(this).closest('.addon-row');
//         const $addonText      = $row.find('.addon-text-field input, .addon-text-field textarea').first();

//         if ($addonText.length) {
//           const addonName = $addonText.attr('name');
//           const addonVal  = $addonText.val().trim();
//           if (addonName && addonVal) addonProperties[addonName] = addonVal;
//         }

//         addonItems.push({ id: variantId, quantity: totalQty, properties: addonProperties });
//       });

//       try {
//         const res = await cartAdd([...addonItems, ...baseItems]);

//         if (!res.ok) {
//           console.error('[custom-multibuy] Shopify error:', res.data);
//           showError(res.data.message || res.data.description || 'Unable to add items to cart. Please try again.');
//           return;
//         }

//         showQtyPopup("Items added to cart!");

//         window.location.href = '/cart';

//       } catch (err) {
//         console.error('[custom-multibuy] Network error:', err);
//         showError('A network error occurred. Please check your connection and try again.');
//       } finally {
//         EL.$form.removeClass('loading');
//         EL.$submitBtn.removeAttr('disabled');
//       }
//     });
//   };

//   // ─────────────────────────────────────────────
//   // FONT SYSTEM
//   // ─────────────────────────────────────────────

//   const normaliseFontOptions = () => {
//     const raw = window.CustomProductFontOptions;
//     if (!Array.isArray(raw)) return [];

//     return raw
//       .map((item) => {
//         if (typeof item === 'string') return { name: item.trim(), url: '' };
//         return {
//           name: String(item?.name ?? '').trim(),
//           url:  String(item?.url  ?? '').trim(),
//         };
//       })
//       .filter((item) => item.name.length > 0);
//   };

//   const loadCustomFonts = (fontOptions) => {
//     if (!('FontFace' in window)) return;

//     fontOptions
//       .filter((f) => f.url)
//       .forEach((f) => {
//         new FontFace(f.name, `url("${f.url}")`)
//           .load()
//           .then((loaded) => document.fonts.add(loaded))
//           .catch(() => console.warn(`[custom-multibuy] Failed to load font: "${f.name}"`));
//       });
//   };

//   const updateFontPreview = () => {
//     if (!EL.$fontPreview.length) return;

//     const selectedFont = EL.$fontSelect.val() || '';
//     const previewText  = (EL.$textInput.val() || '').trim() || 'Sample text';

//     requestAnimationFrame(() => {
//       EL.$fontPreview.text(previewText);
//       EL.$fontPreview.css('font-family', selectedFont ? `"${selectedFont}"` : '');
//     });
//   };

//   const bindFontSystem = () => {
//     loadCustomFonts(normaliseFontOptions());
//     updateFontPreview();

//     // Direct binds — both exist at page load
//     EL.$fontSelect.on('change', updateFontPreview);
//     EL.$textInput.on('input change', updateFontPreview);

//     // Clear validation error as user types
//     EL.$textInput.on('input', function () { clearFieldError($(this)); });
//     EL.$fontSelect.on('change', function () { clearFieldError($(this)); });
//   };

//   // ─────────────────────────────────────────────
//   // DESIGN TAB CHANGE — clear cross-tab validation state
//   // ─────────────────────────────────────────────

//   const bindDesignTabCleanup = () => {
//     // When the user switches between Logo / Text tabs, clear all errors
//     // so stale errors from the previous tab don't show
//     EL.$designBox.find('[data-tab-target]').on('click', () => {
//       clearAllFieldErrors();
//       showError('');
//     });

//     // Also clear logo name and disclaimer errors as user interacts
//     EL.$logoNameInput.on('input', function () { clearFieldError($(this)); });
//     EL.$disclaimer.on('change', function () { clearFieldError($(this)); });
//   };

//   // ─────────────────────────────────────────────
// // STICKY NEXT STEP VISIBILITY
// // Hide until original button goes below fold
// // ─────────────────────────────────────────────

// // ─────────────────────────────────────────────
// // STICKY NEXT STEP VISIBILITY
// // ─────────────────────────────────────────────

// const bindStickyNextStepVisibility = () => {
//   const $sticky = $('.sticky-next-step');

//   if (!$sticky.length) return;

//   const toggleSticky = () => {
//     const shouldHide = window.scrollY < 400;

//     $sticky.toggleClass('hidden', shouldHide);
//   };

//   // initial
//   toggleSticky();

//   window.addEventListener('scroll', toggleSticky, { passive: true });
// };

//   // ─────────────────────────────────────────────
//   // INIT
//   // ─────────────────────────────────────────────

//   const init = () => {
//     // ── Cache all static element references ──
//     EL.$form           = $('#multi-add-atc');
//     EL.$submitBtn      = EL.$form.find('[type="submit"]');
//     EL.$formError      = $('#form-error');
//     EL.$liveTotal      = $('#live-total-price');
//     EL.$liveOriginal   = $('#live-original-price');
//     EL.$liveSavings    = $('#live-savings');
//     EL.$liveSavingsAmt = $('#live-savings-amount');
//     EL.$designBox      = $('.your-design-box');
//     EL.$fontPreview    = $('#fontPreview');
//     EL.$fontSelect     = $('#fontFamilySelect');
//     EL.$textInput      = $('#customTextInput');
//     EL.$logoNameInput  = $('#logoNameInput');
//     EL.$disclaimer     = $('#designDisclaimer');

//     if (!EL.$form.length) {
//       console.warn('[custom-multibuy] Form #multi-add-atc not found. Aborting init.');
//       return;
//     }

//     // ── Build tab context map before binding anything ──
//     buildTabContexts();

//     // ── Load config & bind all interactions ──
//     loadPricingConfig();
//     bindTabClicks();
//     bindSteppers();
//     bindAddonButtons();
//     bindPricingPopup();
//     bindFormSubmit();
//     bindFontSystem();
//     bindDesignTabCleanup();

//     // ── Initial summary render ──
//     updateCartSummary();

//     // sticky next
//     bindStickyNextStepVisibility();
//   };

//   // Expose minimal public surface for external use / debugging
//   return { init, formatMoney, getTier };

// })();

// $(document).ready(() => MultibuyApp.init());




const MultibuyApp = (() => {
  // ─────────────────────────────────────────────
  // PRIVATE STATE
  // ─────────────────────────────────────────────

  let PRICING = { basePrice: 0, tiers: [] };
  let popupTimeout;
  let digitisationVariant = "47828254261435";
  let digitisationPrice = 3500; // £99 in cents - UPDATE THIS TO YOUR ACTUAL PRICE

  // 🔥 GLOBAL STATE - Updated by updateCartSummary()
  let totalPrice = 0;
  let discountedTotal = 0;
  let currentTotalQty = 0;
  let currentSavings = 0;

  function showQtyPopup(message) {
    const popup = document.getElementById("qty-popup");
    if (!popup) return;

    const textEl = popup.querySelector(".qty-popup-text");
    if (textEl) textEl.textContent = message;

    popup.classList.add("show");

    clearTimeout(popupTimeout);
    popupTimeout = setTimeout(() => {
      popup.classList.remove("show");
    }, 2000);
  }

  /**
   * Cached DOM references — populated once in init().
   * Never query the DOM in hot paths (stepper clicks, input events).
   */
  const EL = {
    $form: null,
    $submitBtn: null,
    $formError: null,
    $liveTotal: null,
    $liveOriginal: null,
    $liveSavings: null,
    $liveSavingsAmt: null,
    $designBox: null,
    $fontPreview: null,
    $fontSelect: null,
    $textInput: null,
    $logoNameInput: null,
    $disclaimer: null,
    $digitisationInfo: null,
  };

  /**
   * Tab context map — built once per [data-tabs] container.
   */
  const TAB_CONTEXTS = new Map();

  // ─────────────────────────────────────────────
  // UTILS
  // ─────────────────────────────────────────────

  const debounce = (fn, wait) => {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), wait);
    };
  };

  const formatMoney = (cents) => {
    const amount = (cents / 100).toFixed(2);
    const fmt = window.shopMoneyFormat;
    if (!fmt) return `$${amount}`;
    return fmt.replace(/\{\{[\s]*amount[\s]*\}\}/g, amount);
  };

  // jQuery-style helpers for easier conversion
  const $ = (selector, context = document) => {
    if (typeof selector === 'string') {
      return context.querySelectorAll(selector);
    }
    return selector;
  };

  const on = (element, event, selector, handler) => {
    if (typeof selector === 'function') {
      handler = selector;
      selector = null;
    }
    if (selector) {
      // Event delegation
      element.addEventListener(event, (e) => {
        const target = e.target.closest(selector);
        if (target && element.contains(target)) {
          handler.call(target, e);
        }
      });
    } else {
      element.addEventListener(event, handler);
    }
  };

  const hide = (el) => {
    if (el) el.style.display = 'none';
  };

  const show = (el, display = '') => {
    if (el) el.style.display = display;
  };

  const text = (el, content) => {
    if (content !== undefined) {
      el.textContent = content;
    }
    return el.textContent;
  };

  const html = (el, content) => {
    if (content !== undefined) {
      el.innerHTML = content;
    }
    return el.innerHTML;
  };

  const val = (el, value) => {
    if (value !== undefined) {
      el.value = value;
    }
    return el.value;
  };

  const addClass = (el, className) => {
    if (el) el.classList.add(className);
  };

  const removeClass = (el, className) => {
    if (el) el.classList.remove(className);
  };

  const toggleClass = (el, className, force) => {
    if (el) {
      if (force !== undefined) {
        el.classList.toggle(className, force);
      } else {
        el.classList.toggle(className);
      }
    }
  };

  const hasClass = (el, className) => {
    return el && el.classList.contains(className);
  };

  const attr = (el, name, value) => {
    if (value !== undefined) {
      el.setAttribute(name, value);
    }
    return el.getAttribute(name);
  };

  const removeAttr = (el, name) => {
    el.removeAttribute(name);
  };

  const closest = (el, selector) => {
    return el.closest(selector);
  };

  const find = (el, selector) => {
    return el.querySelectorAll(selector);
  };

  const first = (nodeList) => {
    return nodeList[0];
  };

  const filter = (nodeList, fn) => {
    return Array.from(nodeList).filter(fn);
  };

  // ─────────────────────────────────────────────
  // ERROR / VALIDATION HELPERS
  // ─────────────────────────────────────────────

  const showError = (msg) => {
    if (!msg) {
      if (EL.$formError) {
        hide(EL.$formError);
        text(EL.$formError, '');
      }
      return;
    }
    if (EL.$formError) {
      text(EL.$formError, msg);
      show(EL.$formError, 'block');
      EL.$formError.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  };

  const setFieldError = (field, msg) => {
    if (!field) return;
    addClass(field, 'field--error');
    attr(field, 'aria-invalid', 'true');

    const errorId = `err-${field.id || field.name || Math.random().toString(36).slice(2)}`;
    let errSpan = document.getElementById(errorId);

    if (!errSpan) {
      errSpan = document.createElement('span');
      errSpan.className = 'field-error-msg';
      errSpan.id = errorId;
      errSpan.setAttribute('role', 'alert');
      field.insertAdjacentElement('afterend', errSpan);
    }

    text(errSpan, msg);
    show(errSpan, 'inline-block');
    attr(field, 'aria-describedby', errorId);
  };

  const clearFieldError = (field) => {
    if (!field) return;
    const errorId = attr(field, 'aria-describedby');
    removeClass(field, 'field--error');
    removeAttr(field, 'aria-invalid');
    removeAttr(field, 'aria-describedby');
    if (errorId) {
      const errSpan = document.getElementById(errorId);
      if (errSpan) hide(errSpan);
    }
  };

  const clearAllFieldErrors = () => {
    document.querySelectorAll('.field--error').forEach(field => {
      removeClass(field, 'field--error');
      removeAttr(field, 'aria-invalid');
      removeAttr(field, 'aria-describedby');
    });
    document.querySelectorAll('.field-error-msg').forEach(err => {
      hide(err);
    });
  };

  // ─────────────────────────────────────────────
  // PRICING CONFIG — read from window.discountTiers
  // ─────────────────────────────────────────────

  // const loadPricingConfig = () => {
  //   const data = window.discountTiers;

  //   PRICING = {
  //     tiers: data.tiers.map(t => ({
  //       min: parseInt(t.min, 10) || 0,
  //       discount: parseFloat(t.discount) || 0
  //     }))
  //   };
  // };

  let DEFAULT_TIERS = [];

  const normaliseTiers = (arr) => {
    if (!Array.isArray(arr)) return [];
    return arr
      .map(t => ({
        min: parseInt(t.min, 10) || 0,
        discount: parseFloat(t.discount) || 0
      }))
      .sort((a, b) => a.min - b.min);
  };

  // Har product ki apni tiers uske .pro-box ke data-discount-tiers se,
  // na mile to global default (window.discountTiers).
  const getTiersForBox = (box) => {
    const raw = box ? attr(box, 'data-discount-tiers') : null;
    if (raw) {
      try {
        const norm = normaliseTiers(JSON.parse(raw));
        if (norm.length) return norm;
      } catch (e) {}
    }
    return DEFAULT_TIERS;
  };

  const loadPricingConfig = () => {
    DEFAULT_TIERS = normaliseTiers(window.discountTiers);
  };

  // ─────────────────────────────────────────────
  // PRICING LOGIC
  // ─────────────────────────────────────────────

  // const getTier = (qty) => {
  //   let tier = PRICING.tiers[0];
  //   PRICING.tiers.forEach((t) => { if (qty >= t.min) tier = t; });
  //   return tier;
  // };

  const getTierFor = (tiers, qty) => {
    let tier = tiers[0] || { min: 0, discount: 0 };
    tiers.forEach((t) => { if (qty >= t.min) tier = t; });
    return tier;
  };

  // backward-compatible (public surface + getTotalQty ke liye)
  const getTier = (qty) => getTierFor(DEFAULT_TIERS, qty);

  const getTotalQty = () => {
    let total = 0;
    const quantityInputs = EL.$form.querySelectorAll('.pro-box.active .quantity-input');
    quantityInputs.forEach(input => {
      total += parseInt(val(input), 10) || 0;
    });
    return total;
  };

  // ─────────────────────────────────────────────
  // 🔥 DIGITISATION LOGIC
  // ─────────────────────────────────────────────

  /**
   * Check if digitisation is required (discountedTotal < 25000)
   * and update the UI display accordingly
   * updated logic for digitisation to quantity instead of price now 12+ quantity
   */
  // const needsDigitisation = () => {
  //   return discountedTotal < 25000;
  // };

  const needsDigitisation = () => {
    return currentTotalQty < 12;
  };

  const updateDigitisationDisplay = () => {
    if (!EL.$digitisationInfo) return;

    requestAnimationFrame(() => {
      if (needsDigitisation()) {
        EL.$digitisationInfo.innerHTML = `
          <span class="digitisation-label">Digitisation Fee:</span>
          <span class="digitisation-price">${formatMoney(digitisationPrice)}</span>
        `;
        show(EL.$digitisationInfo, 'inline-block');
      } else {
        hide(EL.$digitisationInfo);
      }
    });
  };

  // ─────────────────────────────────────────────
  // CART SUMMARY — 🔥 NOW UPDATES GLOBAL STATE
  // ─────────────────────────────────────────────

  // const updateCartSummary = () => {
  //   // ── PHASE 1: read all values from DOM ──
  //   let totalQty = 0;
  //   let originalTotal = 0; // in cents
  //   let addonTotal = 0; // in cents

  //   // ── FIRST PASS: get total quantity ──
  //   const activeProducts = EL.$form.querySelectorAll('.pro-box.active .quantity-input');
  //   activeProducts.forEach(input => {
  //     const qty = parseInt(val(input), 10) || 0;
  //     if (qty > 0) totalQty += qty;
  //   });

  //   // ── GET TIER AFTER QTY ──
  //   const tier = getTier(totalQty);
  //   const discountPercent = tier?.discount || 0;

  //   let discountedProductsTotal = 0;

  //   // ── SECOND PASS: Shopify-style per-unit calculation ──
  //   activeProducts.forEach(input => {
  //     const qty = parseInt(val(input), 10) || 0;
  //     if (!qty) return;

  //     const basePriceCents = Math.round((parseFloat(attr(input, 'data-base-price')) || 0) * 100);

  //     // original total
  //     originalTotal += qty * basePriceCents;

  //     // 🔥 Shopify-style: discount per unit, then round
  //     const discountedUnitPrice = Math.round(basePriceCents * (1 - discountPercent / 100));

  //     discountedProductsTotal += qty * discountedUnitPrice;
  //   });

  //   // ── ADDONS (NO DISCOUNT) ──
  //   const addonVariants = EL.$form.querySelectorAll('.addon-variant-id:not(:disabled)');
  //   addonVariants.forEach(addon => {
  //     const basePriceCents = Math.round((parseFloat(attr(addon, 'data-base-price')) || 0) * 100);
  //     addonTotal += basePriceCents * totalQty;
  //   });

  //   // ── FINAL CALCULATIONS ──
  //   let finalTotal = discountedProductsTotal + addonTotal;
  //   const savings = originalTotal - discountedProductsTotal;

  //   // 🔥 UPDATE GLOBAL STATE FIRST (important for digitisation check)
  //   currentTotalQty = totalQty;
  //   totalPrice = originalTotal;
  //   discountedTotal = finalTotal;
  //   currentSavings = savings;

  //   // 🔥 ADD DIGITISATION FEE IF NEEDED (based on discountedTotal BEFORE adding fee)
  //   if (needsDigitisation()) {
  //     finalTotal += digitisationPrice;
  //   }

  //   // ── PHASE 3: write to DOM ──
  //   requestAnimationFrame(() => {
  //     if (EL.$liveTotal) text(EL.$liveTotal, formatMoney(finalTotal));

  //     if (savings > 0) {
  //       if (EL.$liveOriginal) {
  //         text(EL.$liveOriginal, formatMoney(originalTotal));
  //         show(EL.$liveOriginal, 'inline-block');
  //       }
  //       if (EL.$liveSavings) show(EL.$liveSavings, 'inline-block');
  //       if (EL.$liveSavingsAmt) text(EL.$liveSavingsAmt, formatMoney(savings));
  //     } else {
  //       if (EL.$liveOriginal) hide(EL.$liveOriginal);
  //       if (EL.$liveSavings) hide(EL.$liveSavings);
  //     }

  //     // 🔥 UPDATE DIGITISATION DISPLAY
  //     updateDigitisationDisplay();
  //   });
  // };

  const updateCartSummary = () => {
    let totalQty      = 0; // combined 
    let originalTotal = 0; // cents
    let addonTotal    = 0; // cents

    const activeProducts = EL.$form.querySelectorAll('.pro-box.active .quantity-input');

    const productQty = {}; // { productId: qty }
    activeProducts.forEach(input => {
      const qty = parseInt(val(input), 10) || 0;
      if (qty <= 0) return;
      totalQty += qty;
      const box = closest(input, '.pro-box');
      const pid = (box && attr(box, 'data-product-id')) || 'default';
      productQty[pid] = (productQty[pid] || 0) + qty;
    });

    let discountedProductsTotal = 0;

    activeProducts.forEach(input => {
      const qty = parseInt(val(input), 10) || 0;
      if (!qty) return;

      const box = closest(input, '.pro-box');
      const pid = (box && attr(box, 'data-product-id')) || 'default';

      const basePriceCents = Math.round((parseFloat(attr(input, 'data-base-price')) || 0) * 100);
      originalTotal += qty * basePriceCents;

      const tiers           = getTiersForBox(box);
      const tier            = getTierFor(tiers, productQty[pid] || 0);
      const discountPercent = tier?.discount || 0;

      const discountedUnitPrice = Math.round(basePriceCents * (1 - discountPercent / 100));
      discountedProductsTotal += qty * discountedUnitPrice;
    });

    // ── ADDONS (NO DISCOUNT, combined qty) ──
    const addonVariants = EL.$form.querySelectorAll('.addon-variant-id:not(:disabled)');
    addonVariants.forEach(addon => {
      const basePriceCents = Math.round((parseFloat(attr(addon, 'data-base-price')) || 0) * 100);
      addonTotal += basePriceCents * totalQty;
    });

    // ── FINAL ──
    let finalTotal  = discountedProductsTotal + addonTotal;
    const savings   = originalTotal - discountedProductsTotal;

    // 🔥 GLOBAL STATE 
    currentTotalQty = totalQty;
    totalPrice      = originalTotal;
    discountedTotal = finalTotal;
    currentSavings  = savings;

    // 🔥 DIGITISATION FEE
    if (needsDigitisation()) {
      finalTotal += digitisationPrice;
    }

    // ── WRITE TO DOM ──
    requestAnimationFrame(() => {
      if (EL.$liveTotal) text(EL.$liveTotal, formatMoney(finalTotal));

      if (savings > 0) {
        if (EL.$liveOriginal) {
          text(EL.$liveOriginal, formatMoney(originalTotal));
          show(EL.$liveOriginal, 'inline-block');
        }
        if (EL.$liveSavings) show(EL.$liveSavings, 'inline-block');
        if (EL.$liveSavingsAmt) text(EL.$liveSavingsAmt, formatMoney(savings));
      } else {
        if (EL.$liveOriginal) hide(EL.$liveOriginal);
        if (EL.$liveSavings) hide(EL.$liveSavings);
      }

      updateDigitisationDisplay();
    });
  };

  // ─────────────────────────────────────────────
  // TAB SYSTEM
  // ─────────────────────────────────────────────

  const buildTabContexts = () => {
    const tabContainers = document.querySelectorAll('[data-tabs]');
    tabContainers.forEach(container => {
      const buttons = filter(container.querySelectorAll('[data-tab-target]'), btn =>
        closest(btn, '[data-tabs]') === container
      );
      const panels = filter(container.querySelectorAll('[data-tab-panel]'), panel =>
        closest(panel, '[data-tabs]') === container
      );

      TAB_CONTEXTS.set(container, { buttons, panels });
    });
  };

  const switchTab = (btn) => {
    const container = closest(btn, '[data-tabs]');
    if (!container) return;

    const ctx = TAB_CONTEXTS.get(container);
    if (!ctx) return;

    const target = attr(btn, 'data-tab-target');

    ctx.buttons.forEach(button => removeClass(button, 'is-active'));
    ctx.panels.forEach(panel => removeClass(panel, 'is-active'));

    addClass(btn, 'is-active');

    const panel = ctx.panels.find(p => attr(p, 'data-tab-panel') === target);
    if (panel) {
      addClass(panel, 'is-active');

      const focusable = panel.querySelector('button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
      if (focusable) focusable.focus();
    }
  };

  const bindTabClicks = () => {
    const tabButtons = document.querySelectorAll('[data-tab-target]:not(.next-step-btn)');
    tabButtons.forEach(btn => {
      on(btn, 'click', () => {
        if (btn.disabled) return;
        switchTab(btn);
      });
    });

    const nextButtons = document.querySelectorAll('.next-step-btn');
    nextButtons.forEach(btn => {
      on(btn, 'click', (e) => {
        e.preventDefault();

        const target = attr(btn, 'data-tab-target');
        const container = closest(btn, '[data-tabs]');
        if (!container) return;

        const ctx = TAB_CONTEXTS.get(container);
        if (!ctx) return;

        const headerBtn = ctx.buttons.find(b => attr(b, 'data-tab-target') === target && !hasClass(b, 'next-step-btn'));

        if (headerBtn && !headerBtn.disabled) {
          switchTab(headerBtn);
        }
      });
    });
  };

  // ─────────────────────────────────────────────
  // JOURNEY STATE
  // ─────────────────────────────────────────────

  const updateJourneyState = ($context) => {
    const totalQty = getTotalQty();

    const panel = closest($context, '[data-tab-panel]');
    const panelId = attr(panel, 'data-tab-panel');
    const container = closest(panel, '[data-tabs]');
    if (!container) return;

    const ctx = TAB_CONTEXTS.get(container);
    if (!ctx) return;

    const tabBtn = ctx.buttons.find(b => attr(b, 'data-tab-target') === panelId);
    if (tabBtn) {
      toggleClass(tabBtn, 'journey-complete', totalQty > 0);
    }

    const nextBtn = panel.querySelector('.next-step-btn');
    if (!nextBtn) return;

    const nextTarget = attr(nextBtn, 'data-tab-target');
    const nextTabBtn = ctx.buttons.find(b => attr(b, 'data-tab-target') === nextTarget && !hasClass(b, 'next-step-btn'));
    const stickyNextTabBtn = container.querySelector(
      `.sticky-next-step-btn[data-tab-target="${nextTarget}"]`
    );

    if (totalQty > 0) {
      nextBtn.removeAttribute('disabled');
      if (nextTabBtn) nextTabBtn.removeAttribute('disabled');
      if(stickyNextTabBtn) stickyNextTabBtn.removeAttribute('disabled');
    } else {
      nextBtn.setAttribute('disabled', true);
      if (nextTabBtn) nextTabBtn.setAttribute('disabled', true);
      if(stickyNextTabBtn) stickyNextTabBtn.setAttribute('disabled', true);
    }
  };

  // ─────────────────────────────────────────────
  // QUANTITY STEPPER
  // ─────────────────────────────────────────────

  const updateState = (input, value) => {
    const maxAttr = parseInt(attr(input, 'max'), 10);
    const max = isNaN(maxAttr) ? Infinity : maxAttr;

    value = Math.min(max, Math.max(0, parseInt(value, 10) || 0));
    input.value = value;

    const proBox = closest(input, '.pro-box');
    if (proBox) toggleClass(proBox, 'active', value > 0);

    updateCartSummary();
    updateJourneyState(input);
    showError('');
  };

  const bindSteppers = () => {
    const steppers = EL.$form.querySelectorAll('.qty-stepper');
    steppers.forEach(stepper => {
      const input = stepper.querySelector('.quantity-input');
      const plus = stepper.querySelector('.qty-plus');
      const minus = stepper.querySelector('.qty-minus');

      const isAvailable = attr(stepper, 'data-available') === 'true';
      const isTracked = attr(stepper, 'data-track-inventory') === "shopify";
      const availableQty = parseInt(attr(stepper, 'data-available-quantity'), 10);
      const inventoryPolicy = attr(stepper, 'data-inventory-policy');

      let maxQty;
      if (isTracked && inventoryPolicy !== 'continue') {
        maxQty = Math.max(availableQty, 0);
      } else {
        maxQty = 999;
      }

      if (input) attr(input, 'max', maxQty);

      if (minus) {
        on(minus, 'click', () => {
          let value = Number(val(input)) || 0;
          value = Math.max(0, value - 1);
          updateState(input, value);
        });
      }

      if (plus) {
        on(plus, 'click', () => {
          if (!isAvailable) return;

          let value = Number(val(input)) || 0;

          if (value >= maxQty) {
            showQtyPopup("You've reached the maximum available quantity");
            return;
          }

          value = Math.min(maxQty, value + 1);
          updateState(input, value);
        });
      }

      if (input) {
        on(input, 'input', debounce(function () {
          let value = Number(this.value) || 0;

          if (value > maxQty) value = maxQty;
          if (value < 0) value = 0;

          updateState(this, value);
        }, 150));
      }
    });
  };

  // ─────────────────────────────────────────────
  // VALIDATION
  // ─────────────────────────────────────────────

  const validateForm = () => {
    clearAllFieldErrors();

    if (getTotalQty() === 0) {
      return {
        valid: false,
        msg: 'Please select at least one product before adding to cart.',
      };
    }

    const activeDesignPanel = EL.$designBox ? EL.$designBox.querySelector('[data-tab-panel].is-active') : null;
    const activeDesignTab = activeDesignPanel ? attr(activeDesignPanel, 'data-tab-panel') : null;

    if (activeDesignTab === 'design-logo') {
      const logoName = EL.$logoNameInput ? val(EL.$logoNameInput).trim() : '';
      if (!logoName) {
        setFieldError(EL.$logoNameInput, 'Please enter your logo name.');
        return {
          valid: false,
          msg: 'Please complete all required fields.',
          $focus: EL.$logoNameInput,
        };
      }

      const filePondInput = EL.$form.querySelector('[data-tab-panel="design-logo"].is-active .filepond--data input');
      const hasImage = filePondInput && val(filePondInput);

      const nativeFile = EL.$form.querySelector('[data-tab-panel="design-logo"].is-active input[type="file"]');
      const hasNative = nativeFile && nativeFile.files && nativeFile.files.length > 0;

      if (!hasImage && !hasNative) {
        return {
          valid: false,
          msg: 'Please upload your design image before continuing.',
        };
      }

      if (EL.$disclaimer && !EL.$disclaimer.checked) {
        setFieldError(EL.$disclaimer, 'You must confirm ownership of the artwork.');
        return {
          valid: false,
          msg: 'Please confirm you own the rights to the artwork.',
          $focus: EL.$disclaimer,
        };
      }
    }

    if (activeDesignTab === 'design-text') {
      const customText = EL.$textInput ? val(EL.$textInput).trim() : '';
      if (!customText) {
        setFieldError(EL.$textInput, 'Please enter your custom text.');
        return {
          valid: false,
          msg: 'Please enter your custom text.',
          $focus: EL.$textInput,
        };
      }

      if (EL.$fontSelect && EL.$fontSelect.value && !EL.$fontSelect.value) {
        setFieldError(EL.$fontSelect, 'Please select a font family.');
        return {
          valid: false,
          msg: 'Please select a font family.',
          $focus: EL.$fontSelect,
        };
      }
    }

    let addonError = null;
    let $addonFocus = null;

    const activeAddons = EL.$form.querySelectorAll('.addon-row.active');
    activeAddons.forEach(row => {
      const textWrapper = row.querySelector('.addon-text-field');

      if (!textWrapper || hasClass(textWrapper, 'hidden')) return;

      const field = textWrapper.querySelector('input[type="text"], textarea');
      if (!field) return;

      if (!val(field).trim()) {
        const addonTitle = row.querySelector('.addon-title');
        const titleText = addonTitle ? text(addonTitle).trim() : 'addon';
        setFieldError(field, `Please enter text for "${titleText}".`);
        addonError = `Please enter the required text for the "${titleText}" option.`;
        $addonFocus = field;
        return;
      }
    });

    if (addonError) {
      return { valid: false, msg: addonError, $focus: $addonFocus };
    }

    return { valid: true };
  };

  // ─────────────────────────────────────────────
  // CUSTOM PROPERTIES COLLECTOR
  // ─────────────────────────────────────────────

  const getCustomProperties = () => {
    const properties = {};
    const activePanel = EL.$designBox ? EL.$designBox.querySelector('[data-tab-panel].is-active') : null;
    const activeDesignId = activePanel ? attr(activePanel, 'data-tab-panel') : null;

    const customProps = EL.$form.querySelectorAll('.custom-prop');
    customProps.forEach(input => {
      const name = attr(input, 'name');
      if (!name) return;
      if (input.disabled) return;

      const isHidden = input.offsetParent === null;
      const isCheckable = input.type === 'radio' || input.type === 'checkbox';
      if (isHidden && !isCheckable) return;

      const fieldTab = attr(input, 'data-design-tab');
      const insideDesign = closest(input, '.your-design-box') !== null;

      if (fieldTab && insideDesign) {
        if (activeDesignId !== `design-${fieldTab}`) return;
      }

      const type = input.type;

      if (type === 'radio') {
        if (input.checked) properties[name] = val(input);
      } else if (type === 'checkbox') {
        if (input.checked) {
          properties[name] = properties[name]
            ? `${properties[name]}, ${val(input)}`
            : val(input);
        }
      } else {
        const inputVal = val(input);
        if (inputVal && inputVal.trim() !== '') properties[name] = inputVal.trim();
      }
    });

    return properties;
  };

  // ─────────────────────────────────────────────
  // THREAD COLOR LIMIT
  // Max 4 selections
  // ─────────────────────────────────────────────

  const bindThreadColorLimit = () => {
    const checkboxes = document.querySelectorAll('.thread-color-checkbox');

    if (!checkboxes.length) return;

    checkboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', () => {
        const checked = document.querySelectorAll('.thread-color-checkbox:checked');

        if (checked.length > 4) {
          checkbox.checked = false;

          showQtyPopup('Maximum 4 thread colors allowed');
        }
      });
    });
  };

  // ─────────────────────────────────────────────
  // ADDON HANDLER
  // ─────────────────────────────────────────────

  const bindAddonButtons = () => {
    const addonBtns = EL.$form.querySelectorAll('.addon-add-btn');
    addonBtns.forEach(btn => {
      on(btn, 'click', function () {
        const row = closest(this, '.addon-row');
        if (!row) return;

        toggleClass(row, 'active');
        const isActive = hasClass(row, 'active');

        const variantSelect = row.querySelector('.addon-variant-id');
        if (variantSelect) variantSelect.disabled = !isActive;

        const textWrapper = row.querySelector('.addon-text-field');
        if (textWrapper) {
          toggleClass(textWrapper, 'hidden', !isActive);
          const textInputs = textWrapper.querySelectorAll('input, textarea, select');
          textInputs.forEach(field => field.disabled = !isActive);

          if (!isActive) {
            const firstInput = textWrapper.querySelector('input, textarea');
            if (firstInput) clearFieldError(firstInput);
          }
        }

        updateCartSummary();
      });
    });

    const addonTextFields = EL.$form.querySelectorAll('.addon-text-field input, .addon-text-field textarea');
    addonTextFields.forEach(field => {
      on(field, 'input', function () {
        clearFieldError(this);
      });
    });
  };

  // ─────────────────────────────────────────────
  // PRICING POPUP
  // ─────────────────────────────────────────────

  const bindPricingPopup = () => {
    const closeAllPopups = () => {
      const openPopups = EL.$form.querySelectorAll('.pricing-popup.is-open');
      openPopups.forEach(popup => {
        removeClass(popup, 'is-open');
        attr(popup, 'aria-hidden', 'true');
      });
    };

    const popupTriggers = EL.$form.querySelectorAll('.open-pricing-popup');
    popupTriggers.forEach(trigger => {
      on(trigger, 'click', (e) => {
        e.preventDefault();
        const target = attr(trigger, 'data-target');
        if (!target) return;

        closeAllPopups();
        const popup = document.querySelector(target);
        if (popup) {
          addClass(popup, 'is-open');
          attr(popup, 'aria-hidden', 'false');
        }
      });
    });

    const closeButtons = EL.$form.querySelectorAll('.pricing-popup__overlay, .pricing-popup__close');
    closeButtons.forEach(btn => {
      on(btn, 'click', function () {
        const popup = closest(this, '.pricing-popup');
        if (popup) {
          removeClass(popup, 'is-open');
          attr(popup, 'aria-hidden', 'true');
        }
      });
    });

    document.addEventListener('keydown.multibuy', (e) => {
      if (e.key === 'Escape') closeAllPopups();
    });
  };

  // ─────────────────────────────────────────────
  // CART API HELPER
  // ─────────────────────────────────────────────

  const cartAdd = async (items) => {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items }),
    });
    const data = await res.json();
    return { ok: res.ok, data };
  };

  // ─────────────────────────────────────────────
  // FORM SUBMIT — 🔥 NOW INCLUDES DIGITISATION VARIANT
  // ─────────────────────────────────────────────

  const bindFormSubmit = () => {
    on(EL.$form, 'submit', async function (e) {
      e.preventDefault();
      showError('');

      if (hasClass(EL.$form, 'loading')) return;

      const check = validateForm();
      if (!check.valid) {
        showError(check.msg);
        if (check.$focus && check.$focus.length) {
          check.$focus[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
          check.$focus[0].focus();
        }
        return;
      }

      addClass(EL.$form, 'loading');
      if (EL.$submitBtn) EL.$submitBtn.disabled = true;
      let totalQty = 0;

      const globalProperties = getCustomProperties();

      const filepond = EL.$form.querySelector('[data-tab-panel="design-logo"].is-active .filepond--data input');
      if (filepond && val(filepond)) {
        globalProperties['Logo Image'] = val(filepond);
      }

      const baseItems = [];
      const quantityInputs = EL.$form.querySelectorAll('.quantity-input');
      quantityInputs.forEach(input => {
        const qty = parseInt(val(input), 10) || 0;
        const variantId = Number(attr(input, 'data-variant-id'));

        if (qty > 0) {
          if (!variantId) {
            console.warn('[custom-multibuy] Missing variant ID on:', input);
            return;
          }
          totalQty += qty;
          baseItems.push({ id: variantId, quantity: qty, properties: globalProperties });
        }
      });

      if (!baseItems.length) {
        showError('Please select at least one product before adding to cart.');
        removeClass(EL.$form, 'loading');
        if (EL.$submitBtn) EL.$submitBtn.disabled = false;
        return;
      }

      const addonItems = [];
      const addonVariants = EL.$form.querySelectorAll('.addon-variant-id:not(:disabled)');
      addonVariants.forEach(variant => {
        const variantId = Number(val(variant));
        if (!variantId) {
          console.warn('[custom-multibuy] Missing addon variant ID on:', variant);
          return;
        }

        const addonProperties = {};
        const row = closest(variant, '.addon-row');
        if (row) {
          const addonText = row.querySelector('.addon-text-field input, .addon-text-field textarea');
          if (addonText) {
            const addonName = attr(addonText, 'name');
            const addonVal = val(addonText).trim();
            if (addonName && addonVal) addonProperties[addonName] = addonVal;
          }
        }

        addonItems.push({ id: variantId, quantity: totalQty, properties: addonProperties });
      });

      // 🔥 ADD DIGITISATION VARIANT IF NEEDED (discountedTotal < 25000)
      if (needsDigitisation()) {
        addonItems.push({
          id: Number(digitisationVariant),
          quantity: 1,
          properties: {
            '_Digitisation Fee': 'Required for orders under $250'
          }
        });
      }

      try {
        const res = await cartAdd([...addonItems, ...baseItems]);

        if (!res.ok) {
          console.error('[custom-multibuy] Shopify error:', res.data);
          showError(res.data.message || res.data.description || 'Unable to add items to cart. Please try again.');
          return;
        }

        showQtyPopup("Items added to cart!");

        window.location.href = '/cart';

      } catch (err) {
        console.error('[custom-multibuy] Network error:', err);
        showError('A network error occurred. Please check your connection and try again.');
      } finally {
        removeClass(EL.$form, 'loading');
        if (EL.$submitBtn) EL.$submitBtn.disabled = false;
      }
    });
  };

  // ─────────────────────────────────────────────
  // FONT SYSTEM
  // ─────────────────────────────────────────────

  const normaliseFontOptions = () => {
    const raw = window.CustomProductFontOptions;
    if (!Array.isArray(raw)) return [];

    return raw
      .map((item) => {
        if (typeof item === 'string') return { name: item.trim(), url: '' };
        return {
          name: String(item?.name ?? '').trim(),
          url: String(item?.url ?? '').trim(),
        };
      })
      .filter((item) => item.name.length > 0);
  };

  const loadCustomFonts = (fontOptions) => {
    if (!('FontFace' in window)) return;

    fontOptions
      .filter((f) => f.url)
      .forEach((f) => {
        new FontFace(f.name, `url("${f.url}")`)
          .load()
          .then((loaded) => document.fonts.add(loaded))
          .catch(() => console.warn(`[custom-multibuy] Failed to load font: "${f.name}"`));
      });
  };

  const updateFontPreview = () => {
    if (!EL.$fontPreview) return;

    const selectedFont = EL.$fontSelect ? EL.$fontSelect.value || '' : '';
    const previewText = (EL.$textInput ? (val(EL.$textInput) || '').trim() : '') || 'Sample text';

    requestAnimationFrame(() => {
      text(EL.$fontPreview, previewText);
      EL.$fontPreview.style.fontFamily = selectedFont ? `"${selectedFont}"` : '';
    });
  };

  const bindFontSystem = () => {
    loadCustomFonts(normaliseFontOptions());
    updateFontPreview();

    if (EL.$fontSelect) on(EL.$fontSelect, 'change', updateFontPreview);
    if (EL.$textInput) on(EL.$textInput, 'input change', updateFontPreview);
    if (EL.$textInput) on(EL.$textInput, 'input', function () { clearFieldError(this); });
    if (EL.$fontSelect) on(EL.$fontSelect, 'change', function () { clearFieldError(this); });
  };

  // ─────────────────────────────────────────────
  // DESIGN TAB CLEANUP
  // ─────────────────────────────────────────────

  const bindDesignTabCleanup = () => {
    if (EL.$designBox) {
      const designTabs = EL.$designBox.querySelectorAll('[data-tab-target]');
      designTabs.forEach(tab => {
        on(tab, 'click', () => {
          clearAllFieldErrors();
          showError('');
        });
      });
    }

    if (EL.$logoNameInput) on(EL.$logoNameInput, 'input', function () { clearFieldError(this); });
    if (EL.$disclaimer) on(EL.$disclaimer, 'change', function () { clearFieldError(this); });
  };

  // ─────────────────────────────────────────────
  // STICKY NEXT STEP VISIBILITY
  // ─────────────────────────────────────────────

  const bindStickyNextStepVisibility = () => {
    const sticky = document.querySelector('.sticky-next-step');

    if (!sticky) return;

    const toggleSticky = () => {
      const shouldHide = window.scrollY < 400;
      toggleClass(sticky, 'hidden', shouldHide);
    };

    toggleSticky();

    window.addEventListener('scroll', toggleSticky, { passive: true });
  };

  // ─────────────────────────────────────────────
  // INIT
  // ─────────────────────────────────────────────

  const init = () => {
    EL.$form = document.getElementById('multi-add-atc');
    if (!EL.$form) {
      console.warn('[custom-multibuy] Form #multi-add-atc not found. Aborting init.');
      return;
    }

    EL.$submitBtn = EL.$form.querySelector('[type="submit"]');
    EL.$formError = document.getElementById('form-error');
    EL.$liveTotal = document.getElementById('live-total-price');
    EL.$liveOriginal = document.getElementById('live-original-price');
    EL.$liveSavings = document.getElementById('live-savings');
    EL.$liveSavingsAmt = document.getElementById('live-savings-amount');
    EL.$designBox = document.querySelector('.your-design-box');
    EL.$fontPreview = document.getElementById('fontPreview');
    EL.$fontSelect = document.getElementById('fontFamilySelect');
    EL.$textInput = document.getElementById('customTextInput');
    EL.$logoNameInput = document.getElementById('logoNameInput');
    EL.$disclaimer = document.getElementById('designDisclaimer');
    EL.$digitisationInfo = document.getElementById('digitisation-info');


    buildTabContexts();
    bindThreadColorLimit();
    loadPricingConfig();
    bindTabClicks();
    bindSteppers();
    bindAddonButtons();
    bindPricingPopup();
    bindFormSubmit();
    bindFontSystem();
    bindDesignTabCleanup();

    updateCartSummary();
    bindStickyNextStepVisibility();
  };

  return {
    init,
    formatMoney,
    getTier,
    getCurrentQty: () => currentTotalQty,
    getTotalPrice: () => totalPrice,
    getDiscountedTotal: () => discountedTotal,
    getSavings: () => currentSavings,
    needsDigitisation,
  };

})();

document.addEventListener('DOMContentLoaded', () => MultibuyApp.init());